import { useTranslations } from 'next-intl'

import { Hero } from '../components/Hero'

export const HomePage = () => {
  const t = useTranslations('home')
  return <Hero title={t('title')} message={t('message')} />
}
